import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import ListHappyHours from './submodules/list/List';
import CloneHappyHour from './submodules/clone/Clone';
import EditHappyHour from './submodules/edit/Edit';
import CreateHappyHour from './submodules/create/Create';

const HappyHourDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.happyHour}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.happyHour].getHappyHours]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListHappyHours}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.happyHour}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.happyHour].createHappyHour]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/clone`}
				component={CloneHappyHour}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.happyHour}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.happyHour].createHappyHour]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateHappyHour}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.happyHour}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.happyHour].updateHappyHour]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/edit`}
				component={EditHappyHour}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default HappyHourDashboard;
